import(/* webpackMode: "eager" */ "/app/app/widget/page.tsx");
